<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.mode_transport.choisissez_le_mode_de_transport')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected">
                    <div class="font-bold">{{selected.transporteur}}</div>
                    <div class="mt-1 text-xs font-light">
                        <div v-if="selected.prix == 0">Gratuit</div>
                        <div class="flex items-center mt-1">
                            <span v-if="selected.delai != 0">Livraison {{selected.delai}}h</span>
                            <span v-if="selected.delai != 0 && selected.prix > 0" class="mx-2">-</span>
                            <div class="font-bold text-red-500" v-if="selected.prix > 0">Tarif: {{selected.prix}}€</div>
                        </div>
                    </div>
                </template>
            </template>

            <template v-slot:open>
                <template v-if="data">
                    <div
                    v-for="(item, indexItem) in data.colis"
                    :key="'item-' + indexItem"
                    class="p-6 my-4 duration-200 bg-white border border-gray-200 border-gray-300 shadow cursor-pointer my-rounded border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow"
                    @click="end(item)"
                    :test-id="'result-' + indexItem"
                    >
                        <div class="flex items-center">
                            <img v-if="!item.logo" class="h-10 mr-2" :src="require('@/companies/default/img/point_relais.png')" alt="">
                            <div>
                                <img v-if="item.logo" class="h-8 mr-2" :src="item.logo" alt="">
                                <div class="-mb-1 font-bold" v-else>{{item.transporteur}}</div>
                                <div class="mt-1 text-xs font-light">
                                    <span class="lowercase" v-if="item.description">{{item.description.replace(/(\r\n|\n|\r)/gm, "")}}</span>
                                    <span v-if="item.prix == 0">Gratuit</span>
                                    <div class="mt-1.5 mb-1 font-bold text-red-500" v-if="item.prix > 0">{{item.prix}} €</div>
                                    <span v-if="item.delai != 0">Livraison {{item.delai}}h</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import eventHub from '@/eventHub'
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'type-delivery',
    extends: FormCardExtension,

    methods: {
        async init() {
            this.loading = true
            // Check if data
            if (this.$formTool.getFormData('type-delivery')) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData('type-delivery')))
                this.nextBlock = await this.getNextBlock()
                this.emitChange()
            }

            let response = await apiService.post('get_transport', {
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case,
                garantie: JSON.parse(this.$formTool.getFormData('set-case')).garantie,
            })
            this.data = response.data.posts.post

            this.loading = false
        },

        async end(callbackData) {
            let response = await apiService.post('settransport', {
                id_transporteur: callbackData.id,
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case,
                tarif_transport: callbackData.prix
            })

            this.$formTool.addFormData('type-delivery', callbackData)

            if (this.checkStringUrl(response.data.posts.post)) {
                this.$formTool.addFormData('bon_transport', response.data.posts.post)
            }

            this.selected = JSON.parse(JSON.stringify(callbackData))
            this.nextBlock = await this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.emitChange()
        },

        async getNextBlock() {
            if (this.selected.id == '101') {
                return this.$formTool.blockData(this.$options.name).next.relais
            } else {
                let responseAmount = await apiService.post('get_amount', {
                    id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
                })
                let amountData = responseAmount.data.posts.post

                if (Number(amountData.montant_total) > 0) {
                    return this.$formTool.blockData(this.$options.name).next.pay
                } else {
                    return this.$formTool.blockData(this.$options.name).next.free
                }
            }
        },

        checkStringUrl(string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;  
            }
            return url.protocol === "http:" || url.protocol === "https:";
        }
    },

    mounted() {
        this.init()

        eventHub.$on('init-type-delivery', (event) => {
            this.$formTool.removeFormData(this.$options.name)
            this.init()
            this.open = true
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/TypeDeliveryCard.vue